<section class="navbar-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <nav class="navbar navbar-expand-lg">
                    <a class="navbar-brand" href="./">
                        <!-- <img src="assets/images/Logo-0.svg" alt="Logo"> -->
                        <img src="assets/logo-white.png" alt="Logo" style="max-width: 96px;">
                    </a>

                    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTwo"
                        aria-controls="navbarTwo" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="toggler-icon"></span>
                        <span class="toggler-icon"></span>
                        <span class="toggler-icon"></span>
                    </button>

                    <div class="collapse navbar-collapse sub-menu-bar" id="navbarTwo">
                        <ul class="navbar-nav mx-auto">
                            <li class="nav-item">
                                <a class="page-scroll" [routerLink]="['../main']" fragment="home"
                                    routerLinkActive="active">
                                    {{ 'LAYOUT.MENU_HOME' | translate }}
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="page-scroll" [routerLink]="['../main']" fragment="services"
                                    routerLinkActive="active">
                                    {{ 'LAYOUT.MENU_SOLUTIONS' | translate }}
                                </a>
                            </li>
                            <!-- <li class="nav-item"><a class="page-scroll" href="#portfolio">Portfolio</a></li> -->
                            <li class="nav-item">
                                <a class="page-scroll" [routerLink]="['../pricing']" fragment="pricing"
                                    routerLinkActive="active">
                                    {{ 'LAYOUT.MENU_FINANCIAL_PLAN' | translate }}
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="page-scroll" [routerLink]="['../main']" fragment="resources"
                                    routerLinkActive="active">
                                    {{ 'LAYOUT.MENU_RESOURCES' | translate }}
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="page-scroll" [routerLink]="['../main']" fragment="blog"
                                    routerLinkActive="active">
                                    {{ 'LAYOUT.MENU_BLOG' | translate }}
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="page-scroll" [routerLink]="['../main']" fragment="about"
                                    routerLinkActive="active">
                                    {{ 'LAYOUT.MENU_ABOUT' | translate }}
                                </a>
                            </li>
                            <!-- <li class="nav-item"><a class="page-scroll" href="#team">Team</a></li> -->
                            <li class="nav-item">
                                <a class="page-scroll" [routerLink]="['../main']" fragment="contact"
                                    routerLinkActive="active">
                                    {{ 'LAYOUT.MENU_CONTACT' | translate }}
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="navbar-btn propero-section">
                        <a class="btn btn-secondary" href="https://admin.propero.io/" target="_blank">
                            <i class="lni lni-dashboard me-2"></i>
                            Propero
                        </a>
                    </div>

                    <div class="navbar-btn user-profile-section" *ngIf="isLoggedIn && user">
                        <div class="dropdown">
                            <button class="btn btn-secondary dropdown-toggle" id="userProfileDropdown"
                                (click)="toggleDropdown($event)">
                                <i class="lni lni-user me-2"></i>
                                {{ user?.name || user?.username || 'Profile' }}
                            </button>
                            <div class="dropdown-menu" [class.show]="isDropdownOpen">
                                <a class="dropdown-item" (click)="navigateToProfile()">
                                    <i class="lni lni-user me-2"></i>
                                    {{ 'LAYOUT.MENU_PROFILE' | translate }}
                                </a>
                                <a class="dropdown-item" (click)="logout()">
                                    <i class="lni lni-exit me-2"></i>
                                    {{ 'LAYOUT.MENU_LOGOUT' | translate }}
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="navbar-btn login-section" *ngIf="!isLoggedIn">
                        <ul>
                            <li>
                                <a class="solid" [routerLink]="['/login']">
                                    {{ 'LAYOUT.MENU_LOGIN' | translate }}
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="navbar-btn language-section">
                        <div class="dropdown">
                            <button class="btn btn-secondary dropdown-toggle" id="languageDropdown"
                                (click)="toggleLanguageDropdown($event)">
                                <i class="lni lni-world me-2"></i>
                                {{ translate.currentLang.toUpperCase() }}
                            </button>
                            <div class="dropdown-menu" [class.show]="isLanguageDropdownOpen">
                                <a class="dropdown-item" *ngFor="let lang of translate.getLangs()"
                                    (click)="onChangeLanguage(lang)">
                                    <i class="lni lni-flag me-2"></i>
                                    {{ lang.toUpperCase() }}
                                </a>
                            </div>
                        </div>
                    </div>

                </nav> <!-- navbar -->
            </div>
        </div> <!-- row -->
    </div> <!-- container -->
</section>

<!--====== NAVBAR TWO PART ENDS ======-->


<router-outlet></router-outlet>


<!--====== BACK TOP TOP PART START ======-->

<a routerLink="./" class="back-to-top"><i class="lni lni-chevron-up"></i></a>

<!--====== BACK TOP TOP PART ENDS ======-->


<!--====== NAVBAR TWO PART ENDS ======-->


<!--====== FOOTER PART START ======-->

<section class="footer-area footer-dark">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-3">
                <div class="footer-brand">
                    <div class="logo-wrapper mb-4">
                        <img src="assets/logo-white.png" alt="Logo" class="footer-logo img-fluid"
                            style="max-width: 150px;">
                    </div>
                    <div class="footer-contact">
                        <h4 class="footer-title text-white mb-3"> {{ 'LAYOUT.CONTACT_US' | translate }}</h4>
                        <div class="contact-info">
                            <p class="d-flex align-items-center mb-3 text-light">
                                <i class="lni lni-phone-set me-3 fs-4 text-primary"></i>
                                <span class="text-light"> {{ 'COMPANY.CONTACT_MAIN_PHONE' | translate }}</span>
                            </p>
                            <p class="d-flex align-items-center mb-3 text-light">
                                <i class="lni lni-envelope me-3 fs-5 text-primary"></i>
                                <span class="text-light"> {{ 'COMPANY.CONTACT_MAIN_EMAIL' | translate }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-3">
                <h4 class="footer-title text-white mb-3"> {{ 'LAYOUT.SUPPORT' | translate }}</h4>
                <ul class="footer-links list-unstyled">
                    <li class="mb-2"><a [routerLink]="['/contact']" class="text-light text-decoration-none hover-link">
                            {{ 'LAYOUT.CONTACT_US' | translate }}</a></li>
                    <li class="mb-2"><a [routerLink]="['/legal/privacy']"
                            class="text-light text-decoration-none hover-link"> {{ 'LAYOUT.LEGAL_ADVISORY' | translate
                            }}</a></li>
                    <li class="mb-2"><a [routerLink]="['/legal/privacy-policy']"
                            class="text-light text-decoration-none hover-link"> {{ 'LAYOUT.LEGAL_PRIVACY_POLICY' |
                            translate }}</a></li>
                    <li class="mb-2"><a [routerLink]="['/legal/cookie-preferences']"
                            class="text-light text-decoration-none hover-link"> {{ 'LAYOUT.LEGAL_COOKIE_PREFERENCES' |
                            translate }}</a>
                    </li>
                    <li class="mb-2"><a [routerLink]="['/legal/terms']"
                            class="text-light text-decoration-none hover-link"> {{ 'LAYOUT.LEGAL_TERMS' | translate
                            }}</a></li>
                    <li class="mb-2"><a [routerLink]="['/sitemap']" class="text-light text-decoration-none hover-link">
                            {{ 'LAYOUT.MENU_SITEMAP' | translate }}</a></li>
                </ul>
            </div>

            <div class="col-lg-3">
                <h4 class="footer-title text-white mb-3"> {{ 'LAYOUT.MENU_COMPANY' | translate }}</h4>
                <ul class="footer-links list-unstyled">
                    <li class="mb-2"><a [routerLink]="['/about-us']" class="text-light text-decoration-none hover-link">
                            {{ 'LAYOUT.MENU_ABOUT_US' | translate }}</a></li>
                    <li class="mb-2"><a [routerLink]="['/careers']" class="text-light text-decoration-none hover-link">
                            {{ 'LAYOUT.MENU_CAREERS' | translate }}</a></li>
                    <li class="mb-2"><a [routerLink]="['/blog']" class="text-light text-decoration-none hover-link">
                            {{ 'LAYOUT.MENU_BLOG' | translate }}</a></li>
                </ul>

                <h4 class="footer-title text-white mt-4 mb-3"> {{ 'LAYOUT.MENU_COLLABORATION' | translate }}</h4>
                <ul class="footer-links list-unstyled">
                    <li class="mb-2"><a [routerLink]="['/collaboration']" [fragment]="'owner'"
                            class="text-light text-decoration-none hover-link"> {{ 'LAYOUT.MENU_COLLABORATION_OWNER' |
                            translate }}</a></li>
                    <li class="mb-2"><a [routerLink]="['/collaboration']" [fragment]="'agent'"
                            class="text-light text-decoration-none hover-link"> {{ 'LAYOUT.MENU_COLLABORATION_AGENT' |
                            translate }}</a></li>
                    <li class="mb-2"><a [routerLink]="['/collaboration']" [fragment]="'manager'"
                            class="text-light text-decoration-none hover-link"> {{ 'LAYOUT.MENU_COLLABORATION_MANAGER' |
                            translate }}</a></li>
                </ul>
            </div>

            <div class="col-lg-3">
                <h4 class="footer-title text-white mb-3"> {{ 'LAYOUT.MENU_MOBILE' | translate }}</h4>
                <div class="mobile-apps mb-4">
                    <div class="d-flex flex-column gap-3">
                        <a href="https://play.google.com/store/apps/details?id=io.propero.app" target="_blank"
                            class="d-inline-block">
                            <img src="assets/images/google-play-badge.svg" alt="Get it on Google Play"
                                class="app-store-btn img-fluid">
                        </a>
                        <a href="https://apps.apple.com/app/propero/id1234567890" target="_blank"
                            class="d-inline-block">
                            <img src="assets/images/app-store-badge.svg" alt="Download on the App Store"
                                class="app-store-btn img-fluid">
                        </a>
                    </div>
                </div>

                <h4 class="footer-title text-white mb-3">
                    {{ 'LAYOUT.MENU_PAYMENT' | translate }}
                </h4>
                <div class="payment-methods">
                    <div class="payment-grid">
                        <div class="payment-column">
                            <img src="assets/images/payment/google-pay.svg" alt="Google Pay" class="payment-icon"
                                style="max-width: 70px;">
                            <img src="assets/images/payment/visa.svg" alt="Visa" class="payment-icon"
                                style="max-width: 70px;">
                        </div>
                        <div class="payment-column">
                            <img src="assets/images/payment/mastercard.svg" alt="Mastercard" class="payment-icon"
                                style="max-width: 70px;">
                            <img src="assets/images/payment/stripe.svg" alt="Stripe" class="payment-icon"
                                style="max-width: 70px;">
                        </div>
                    </div>
                </div>


            </div>
        </div>

        <div class="footer-bottom pt-4 mt-5 border-top border-secondary">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <div class="copyright text-light">
                        <p class="mb-0">© {{ currentYear }} Propero.io. {{ 'LAYOUT.MENU_ALL_RIGHTS_RESERVED' | translate
                            }}</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="social-links-wrapper">
                        <ul class="social-links list-unstyled d-flex justify-content-end mb-0">
                            <li><a href="https://facebook.com/propero" target="_blank" class="social-link text-light"><i
                                        class="lni lni-facebook-filled"></i></a></li>
                            <li><a href="https://twitter.com/propero" target="_blank" class="social-link text-light"><i
                                        class="lni lni-twitter-original"></i></a></li>
                            <li><a href="https://instagram.com/propero" target="_blank"
                                    class="social-link text-light"><i class="lni lni-instagram-original"></i></a></li>
                            <li><a href="https://linkedin.com/company/propero" target="_blank"
                                    class="social-link text-light"><i class="lni lni-linkedin-original"></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!--====== FOOTER PART ENDS ======-->